import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {MY_TEAMS} from '/enum/records.enum';
import {getViewTeams} from '/redux/action/myTeams.action';
import {MyteamsReduxKeys, resetReport} from '/redux/action/report.action';
import {
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
  rankDescriptionById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {
  hasTeamsByCoachId,
  reportCountAllOrg,
  reportFilterCount,
  selectedCoachId,
  viewTeamsLoadingState,
} from '/redux/selector/myTeams.selector';
import {allReportData, reportMeta} from '/redux/selector/report.selector';
import {
  downlineCoachIds,
  watchlistCount,
} from '/redux/selector/watchList.selector';
import {withProps} from '/util/selector.util';

import MyTeamsReportList from './MyTeamsReportList';

export default connect(
  createStructuredSelector({
    downlineCoachIds,
    watchlistCount,
    viewTeams: (state: any) => state.myTeams?.viewTeams,
    hasTeamsByCoach: hasTeamsByCoachId,
    coachId: selectedCoachId,
    myTeamsReportMeta: withProps({
      reportName: MY_TEAMS,
    })(reportMeta),
    isViewTeamsLoading: viewTeamsLoadingState,
    myTeamsReportData: allReportData,
    allReportData,
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    highestAchievedRank: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
    coachCurrentRank: withProps({coachId: userId})(rankDescriptionById),
    viewTeamsReportFilterCount: reportFilterCount,
    viewTeamsReportCountAllOrg: reportCountAllOrg,
  }),
  dispatch => ({
    getViewTeams: ({
      coachId,
      pageNumber,
      reportName,
      appendData,
      reportParams,
      ...filtersData
    }: any) =>
      dispatch<any>(
        getViewTeams({
          coachId,
          pageNumber,
          reportName,
          appendData,
          reportParams: reportParams ?? [filtersData],
        }),
      ),

    resetReport: ({reportKey}: any) =>
      dispatch<any>(resetReport({reportKey, data: null})),
  }),

  (stateProps, dispatchProps, ownProps) => {
    const {
      recordId,
      coachId,
      pageNumber,
      reportName,
      appendData,
      ...filtersData
    } = ownProps;

    const effectiveCoachId = coachId || recordId;

    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      fetchData: () => {
        return dispatchProps.getViewTeams({
          coachId: effectiveCoachId,
          pageNumber,
          reportName,
          appendData,
          reportParams: [filtersData],
        });
      },
      resetMyTeamsData: () => {
        MyteamsReduxKeys.forEach(element =>
          dispatchProps.resetReport({reportKey: element}),
        );
      },
    };
  },
)(MyTeamsReportList);
